/**
 * usePendingRoomJoin.js
 * Utility-Funktionen für pending room join (Invite-Link vor Login).
 *
 * Der Slug wird in localStorage gespeichert und von useStammtischRoomInit konsumiert.
 */

const STORAGE_KEY = 'pending_room_join';

/**
 * Speichert einen Raum-Slug für späteren Join (z.B. vor Login)
 */
export function setPendingRoomJoin(slug) {
  localStorage.setItem(STORAGE_KEY, slug);
  console.log('[PendingRoomJoin] Set pending join:', slug);
}

/**
 * Prüft ob ein pending room join existiert
 */
export function getPendingRoomJoin() {
  return localStorage.getItem(STORAGE_KEY);
}

/**
 * Löscht den pending room join
 */
export function clearPendingRoomJoin() {
  localStorage.removeItem(STORAGE_KEY);
}
